export default "__VITE_ASSET__BbOQeW4H__"